import { useMemo } from 'react'
import { IntlShape, MessageDescriptor } from 'react-intl'

import { ClientObject } from '../../../models/client/Client'
import { MANAGER_COACHING_TITLE } from '../../common/constants/treatmentOptionsMessages'
import { MANAGER_COACHING_PROGRAM_TYPE } from '../../managerCoaching/seatEligibility'

const LICENSE_SESSION_COUNT_PROGRAM_TYPE_LABELS: Partial<Record<string, MessageDescriptor>> = {
  [MANAGER_COACHING_PROGRAM_TYPE]: MANAGER_COACHING_TITLE,
}

export const useGetLicenseSessionCount = (intl: IntlShape, clientDetails?: ClientObject | null) => {
  const licenses = clientDetails?.seat_based_licenses
  return useMemo(() => {
    if (!licenses) {
      return undefined
    }

    return licenses.map((license) => {
      const programTypeLabel = LICENSE_SESSION_COUNT_PROGRAM_TYPE_LABELS[license.program_type]
      return {
        label: intl.formatMessage(
          {
            defaultMessage: '{programType} sessions used',
            description: 'Label for license session count',
          },
          {
            programType: programTypeLabel ? intl.formatMessage(programTypeLabel) : license.program_type,
          },
        ),
        value: intl.formatMessage(
          {
            defaultMessage: '{sessionsUsed} of {totalSessionsCount}',
            description: 'Value for license session count',
          },
          {
            sessionsUsed: license.sessions_used,
            totalSessionsCount: license.sessions_total,
          },
        ),
        sublabel: intl.formatMessage(
          {
            defaultMessage: 'Expires on {accessEndDate}',
            description: 'Sublabel showing when license sessions expire',
          },
          {
            accessEndDate: intl.formatDate(license.access_end_date, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              timeZone: 'UTC',
            }),
          },
        ),
      }
    })
  }, [licenses, intl])
}
